import React from "react";
import bitcoin from "../Image/bitcoin_gray@1x 1.png";
import etherum from "../Image/ethereum_gray@1x 1.png";
import bnbchain from "../Image/binance_gray@1x 1.png";
import tron from "../Image/tron_gray@1x 1.png";
import tether from "../Image/tether_gray@1x 1.png";
import biswap from "../Image/biswap_gray@1x 1.png";
import { Container, Row, Col } from "react-bootstrap";

function Sec2() {
  return (
    <div className="hero-section">
      <div className="stats-bar container">
        <div className="stat-item">
          <h1>12</h1>
          <h5>
            Crypto <br />
            networks
          </h5>
        </div>

        <div className="divider"></div>

        <div className="stat-item">
          <h1>56</h1>
          <h5>Currencies</h5>
        </div>

        <div className="divider"></div>

        <div className="coins">
          <span> <img src={bitcoin} alt="" /></span>
         
          <span><img src={etherum} alt="" /></span>
          <span><img src={bnbchain} alt="" /></span>
          <span><img src={tron} alt="" /></span>
          <span><img src={tether} alt="" /></span>
          <span><img src={biswap} alt="" /></span>
        </div>
        <div className="divider"></div>

        <div className="show-all flex-column">
         Show all
        </div>
      </div>
    </div>
  );
}

export default Sec2;
